var SelectModule = require('../modules/select')

var Module = {
    name: 'box_count',
    selectors: {
        select2: '#box-count',
    },

    init: function (eventID = '') {
        Module.select2Init(eventID);
    },

    select2Init: function (eventID = '') {
        let select = null;
        if (!eventID) {
            select = $(document).find(Module.selectors.select2);
        } else {
            select = $('[data-event-id="'+eventID+'"][data-name="box_count"]');
        }
        if (select.length) {
            SelectModule.init(select);
        }
        if (select.data('value')) {
            select.val(select.data('value')).trigger('change');
        }
    },
}

module.exports = Module
